export const SET_DEVICES="app/devicesList/SET_DEVICES"
